import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout/Layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/homeNew/index.js')
      },
      {
        path: 'space',
        name: 'space',
        component: () => import('@/views/space/index.js')
      },
      {
        path: 'goods_feedback',
        name: 'goods_feedback',
        component: () => import('@/views/goodsfeedback/index.js')
      },
      {
        path: 'test',
        name: 'test',
        component: () => import('@/views/test/index.js')
      },
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/member/index.js')
      },
      {
        path: 'choice',
        name: 'choice',
        component: () => import('@/views/choice/index.js')
      },
      {
        path: 'live',
        name: 'live',
        component: () => import('@/views/live/index.js')
      }
    ]
  },
  {
    path: '/wxGuide',
    name: 'wxGuide',
    component: () => import('@/views/wxGuide/index.js')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
